import React, { useState } from 'react';

export default function PayrunForm({ payrun, onSave }) {
  const [formData, setFormData] = useState({ ...payrun });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 max-w-xl">
      {['grossPay', 'netPay', 'tax', 'superannuation'].map((field) => (
        <div key={field}>
          <label className="block font-medium capitalize">{field}</label>
          <input
            type="number"
            name={field}
            value={formData[field]}
            onChange={handleChange}
            className="border px-3 py-1 w-full"
          />
        </div>
      ))}
      <button
        type="submit"
        className="bg-green-500 text-white px-4 py-2 rounded"
      >
        Save
      </button>
    </form>
  );
}
